"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const SysadminImpersonateFlash = ({ session }) => {
    if (session.user.sysadminId) {
        return (react_1.default.createElement(polaris_1.Flash, { type: "error", content: `Warning: You are impersonating this user. Avoid creating or editing resources to prevent confusion.` }));
    }
    return null;
};
exports.default = SysadminImpersonateFlash;
//# sourceMappingURL=SysadminImpersonateFlash.js.map